'use strict';

import Vue from 'vue/dist/vue.common.js';
import { uniqueId } from 'lodash';
import cookie from "fg-cookie";

let Alert = Vue.extend({

  data() {
    return {
      id: "change:signup",
      enabled: false
    }
  },

  mounted() {
    const val = cookie(this.id);
    if (!val) {
      this.enabled = true;
    }
  },

  methods: {
    disable() {
      cookie(this.id, 1);
      this.enabled = false;
    }
  },
});

export default Alert;



// WEBPACK FOOTER //
// ./app/javascript/vue/instances/alert.js